import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './global.css';
import './responsive.css';

// ── Global Chunk Load Error Handler ───────────────────────────────────────────
// Detects stale chunks after a deploy and prompts the user to refresh.
window.addEventListener('error', (event) => {
  const msg = event.message || '';
  const isChunkError =
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk') ||
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module');

  if (isChunkError) {
    showRefreshBanner();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || String(event.reason) || '';
  const isChunkError =
    reason.includes('Loading chunk') ||
    reason.includes('Loading CSS chunk') ||
    reason.includes('Failed to fetch dynamically imported module') ||
    reason.includes('Importing a module script failed') ||
    reason.includes('error loading dynamically imported module');

  if (isChunkError) {
    showRefreshBanner();
  }
});

function showRefreshBanner() {
  // Only show once
  if (document.getElementById('kdu-refresh-banner')) return;

  const banner = document.createElement('div');
  banner.id = 'kdu-refresh-banner';
  banner.style.cssText = `
    position: fixed; bottom: 0; left: 0; right: 0; z-index: 99999;
    background: linear-gradient(135deg, #1a6b3c, #0f4a28);
    color: #fff; padding: 14px 20px;
    display: flex; align-items: center; justify-content: space-between;
    gap: 12px; font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    box-shadow: 0 -4px 20px rgba(0,0,0,0.3);
  `;
  banner.innerHTML = `
    <div style="flex:1;">
      <div style="font-weight:700;font-size:0.9rem;">New version available</div>
      <div style="font-size:0.75rem;opacity:0.85;margin-top:2px;">The app has been updated. Please refresh to continue.</div>
    </div>
    <button onclick="window.location.reload()" style="padding:10px 20px;background:#fff;color:#1a6b3c;border:none;border-radius:8px;font-weight:700;font-size:0.85rem;cursor:pointer;white-space:nowrap;">
      Refresh Now
    </button>
  `;
  document.body.appendChild(banner);
}

// ── Render App ────────────────────────────────────────────────────────────────

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
